import Toasted from 'vue-toasted'
import Vue from 'vue'
import Store from '@/state'

Vue.use(Toasted, {
  position: 'bottom-right',
  type: 'error',
  duration: 3000
})

export default (err) => {
  const errorMessage = err.response.data.message
  switch (errorMessage) {
    case 'Your token is not valid':
      invalidToken()
      break
    case 'teste':
      noPermissionToThisArea()
      break
    default:
      unhandledError(errorMessage)
  }
  return Promise.reject(err)
}

const invalidToken = () => {
  Vue.toasted.error('Seu token expirou!')
  Store.dispatch('Login/FORCE_EXPIRE', {expireStatus: 'EXPIRED'})
}

const noPermissionToThisArea = () => {
  Vue.toasted.info('Você não tem permissão para acessar este recurso')
}

const unhandledError = (errorMessage) => {
  console.log('erro', errorMessage)
  Vue.toasted.error(errorMessage)
}



// WEBPACK FOOTER //
// ./src/communication/HandleRequestError.js